import React, { useState } from 'react';

// The caller keys this by URL and refresh count so an image that wasn't ready
// during transcoding is retried when the admin refreshes the import.
const Thumbnail = ({ src, fallbackSrc, alt }) => {
    const [failed, setFailed] = useState([]);
    const url = [src, fallbackSrc].find((candidate) => candidate && !failed.includes(candidate));
    return url
        ? <img className="bsi-thumb" src={url} alt={alt} loading="lazy" onError={() => setFailed((prev) => [...prev, url])} />
        : <span className="bsi-thumb" role="img" aria-label={`${alt} not available`}><i className="fas fa-film" aria-hidden="true" /></span>;
};

export default Thumbnail;
